// assets
import {
    IconTypography,
    IconPalette,
    IconShadow,
    IconWindmill,
    IconWallet,
    IconArrowBigUpLines,
    IconDeviceMobile,
    IconHandFinger,
    IconArrowsTransferDown,
    IconQrcode,
    IconCreditCard,
    IconFingerprint,
    IconDeviceMobileMessage,
    IconMoneybag,
    IconCircleNumber2,
    IconBuildingBank
    // IconCash
    // IconArrowAutofitRight
} from '@tabler/icons';
// constant
const icons = {
    IconTypography,

    IconPalette,
    IconShadow,
    IconWindmill,
    IconWallet,
    IconArrowBigUpLines,
    IconDeviceMobile,
    IconHandFinger,
    IconArrowsTransferDown,
    IconQrcode,
    IconCreditCard,
    IconFingerprint,
    IconDeviceMobileMessage,
    IconMoneybag,
    IconCircleNumber2,
    IconBuildingBank
    // IconArrowAutofitRight
};

// ==============================|| UTILITIES MENU ITEMS ||============================== //
const mobileBankingStatus = localStorage.getItem('mobileBanking');
const rmemployee = localStorage.getItem('rmemployee') === 'true';

const email = (localStorage.getItem('email_id') || '').trim().toLowerCase();
// const allowedDmt3Emails = [

//     'sruthys240@gmail.com',
//     'aaleenaa22@gmail.com',
//     'sruthyfeb21@gmail.com',
//     'sharon@acemoney.in',
//     'annikitthomas@gmail.com'
// ];
// const dmt3Test = allowedDmt3Emails.includes(email);

const allowedDmtBetaEmails = ['merindixon@acemoney.in', 'sruthys240@gmail.com'];
const checkAgentEmail = allowedDmtBetaEmails.includes(email);
const fingpayAepsStatus = localStorage.getItem('fingpay_aeps_status');
const finoAepsStatus = localStorage.getItem('fino_aeps_status');
const airtelAepsStatus = localStorage.getItem('airtel_aeps_status');
// const whiteLabelStatue = localStorage.getItem('whitelabelStatus');
const Wallets = {
    id: 'newUtilities',
    title: 'Banking Services',
    type: 'collapse',
    icon: icons.IconBuildingBank,
    children: [
        {
            id: 'icons2',
            title: 'Domestic Money Transfer',
            type: 'collapse',
            icon: icons.IconArrowsTransferDown,
            children: [
                {
                    id: 'dmtFino',
                    title: 'DMT 1',
                    type: 'item',
                    url: 'dmt/dmtTable',
                    breadcrumbs: false,
                    icon: icons.IconMoneybag
                },
                // {
                //     id: 'dmtIserVue',
                //     title: 'DMT 2',
                //     type: 'item',
                //     url: 'dmt2/dmt-customerlist',
                //     breadcrumbs: false,
                //     icon: icons.IconMoneybag
                // },
                // dmt3Test &&
                {
                    id: 'dmtAirtel',
                    title: 'DMT 2',
                    type: 'item',
                    url: 'dmt3/dmt-customerlist',
                    breadcrumbs: false,
                    icon: icons.IconMoneybag,
                    isNew: true
                }
            ]
        },
        checkAgentEmail && {
            id: 'icons2-dmt',
            title: 'Domestic Money Transfer(Beta)',
            type: 'collapse',
            icon: icons.IconArrowsTransferDown,
            children: [
                {
                    id: 'dmtFino1',
                    title: 'DMT 1',
                    type: 'item',
                    url: 'moneyTransfer1/viewCustomers',
                    breadcrumbs: false,
                    icon: icons.IconMoneybag
                },
                {
                    id: 'dmtIserVue2',
                    title: 'DMT 2',
                    type: 'item',
                    url: 'moneyTransfer2/viewCustomers',
                    breadcrumbs: false,
                    icon: icons.IconMoneybag
                }
            ]
        },
        // checkAgentEmail && {
        //     id: 'icons2-dmt',
        //     title: 'Domestic Money Transfer(Beta)',
        //     type: 'collapse',
        //     icon: icons.IconArrowsTransferDown,
        //     children: [
        //         {
        //             id: 'dmtFino1',
        //             title: 'DMT 1',
        //             type: 'item',
        //             url: 'moneyTransfer1/viewCustomers',
        //             breadcrumbs: false,
        //             icon: icons.IconMoneybag
        //         },
        //         {
        //             id: 'dmtIserVue2',
        //             title: 'DMT 2',
        //             type: 'item',
        //             url: 'moneyTransfer2/viewCustomers',
        //             breadcrumbs: false,
        //             icon: icons.IconMoneybag
        //         }
        //     ]
        // },
        !rmemployee && {
            id: 'matm',
            title: 'MATM',
            type: 'collapse',
            icon: icons.IconDeviceMobile,
            children: [
                {
                    id: 'matm4',
                    title: 'Multi-Purpose Onboarding',
                    type: 'item',
                    url: 'matm/iserveu-matm-registration',
                    caption: 'AEPS/MATM/POS',
                    breadcrumbs: false
                }
            ]
        },
        //aeps fingpay
        !rmemployee &&
            fingpayAepsStatus == 'true' && {
                id: 'icons9986',
                title: 'AEPS 1',
                type: 'item',
                icon: icons.IconHandFinger,
                url: 'aeps/aeps1',
                breadcrumbs: false
            },
        //aeps fino
        !rmemployee &&
            finoAepsStatus == 'true' && {
                url: 'aeps/aeps2',
                id: 'AEPS2NEW',
                title: 'AEPS 2',
                type: 'item',
                icon: icons.IconHandFinger,
                breadcrumbs: false
            },
        //....aeps airtel (based on the backedn condition only one aeps will be shown, thats why id and url are same as aeps2).......
        !rmemployee &&
            airtelAepsStatus == 'true' && {
                id: 'icons9996',
                url: 'aeps/aeps3',
                title: 'AEPS 2',
                type: 'item',
                icon: icons.IconHandFinger,
                breadcrumbs: false
            },
        checkAgentEmail && {
            id: 'icons9986-aeps',
            title: 'AEPS 1(Beta)',
            type: 'item',
            icon: icons.IconHandFinger,
            url: 'aeps1/aeps',
            breadcrumbs: false
        },
        // !rmemployee && {
        //     id: 'icons9786',

        //     title: 'AEPS 2',
        //     type: 'collapse',
        //     icon: icons.IconHandFinger,
        //     children: [
        //         {
        //             id: 'cashDepositMenu',
        //             title: 'Cash Deposit',
        //             type: 'item',
        //             icon: icons.IconOutbound,
        //             url: 'aeps/aeps-sdk-cashdeposit',
        //             breadcrumbs: false
        //         },
        //         {
        //             id: 'tabler-icons51',
        //             title: 'Balance Enquiry',
        //             type: 'item',
        //             url: 'aeps/aeps-sdk-balanceenquiry',
        //             breadcrumbs: false
        //         },
        //         {
        //             id: 'tabler-icons62',
        //             title: 'Cash Withdrawal',
        //             type: 'item',
        //             url: 'aeps/aeps-sdk-cw',
        //             breadcrumbs: false
        //         },
        //         {
        //             id: 'tabler-icons73',
        //             title: ' Mini Statement ',
        //             type: 'item',
        //             url: 'aeps/aeps-sdk-ministatement',
        //             breadcrumbs: false
        //         }
        //     ]
        // },

        {
            id: 'icons07',
            title: 'Aadhaar Pay',
            type: 'item',
            icon: icons.IconFingerprint,
            url: 'aadhaarpay/aadhaarpay',
            breadcrumbs: false
            // children: [
            //     {
            //         id: 'tabler-icons1',
            //         title: 'Instant Transfer',
            //         type: 'item',
            //         url: 'dmt/dmtTable',
            //         breadcrumbs: false
            //     }
            // ]
        },
        checkAgentEmail && {
            id: 'icons0722',
            title: 'Aadhaar Pay(Beta)',
            type: 'item',
            icon: icons.IconFingerprint,
            url: '/aeps1/aadhaarpay',
            breadcrumbs: false
        },

        {
            id: 'tabler-icons881',
            title: 'My QR',
            type: 'item',
            icon: icons.IconQrcode,
            url: 'qr/myqr',
            breadcrumbs: false
        },
        // {
        //     id: 'tabler-icons882',
        //     title: 'UPI ATM',
        //     type: 'item',
        //     icon: icons.IconCreditCard,
        //     url: '/atmupi',
        //     breadcrumbs: false
        // },
        // {
        //     id: 'tabler-icons8822',
        //     title: 'Credit',
        //     type: 'item',
        //     icon: icons.IconArrowAutofitRight,
        //     url: '/credit',
        //     breadcrumbs: false
        // },
        mobileBankingStatus === 'true'
            ? {
                  id: 'tabler-icons8821',
                  title: 'Mobile Banking',
                  type: 'item',
                  icon: icons.IconDeviceMobileMessage,
                  url: 'mobile-banking/mobilebanking-list',
                  breadcrumbs: false
              }
            : null
    ].filter(Boolean)
};

export default Wallets;
